<template>
  <transition name="toast-slide">
    <div
      @mouseover="clearTimer"
      @mouseleave="startTimer"
      class="toast"
      :class="[`toast--${alert}`]"
      v-if="display"
    >
      <div class="toast__icon">
        <svg v-if="alert === 'success'" width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M22 4L12 14.01L9 11.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <svg v-else-if="alert === 'error'" width="20" height="20" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
          <path d="M15 9L9 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          <path d="M9 9L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
          <path d="M12 16V12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          <path d="M12 8H12.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </div>
      <div class="toast__content">
        <h4 class="toast__title">
          {{ messageTitle ? capitalize(messageTitle) : capitalize(alert) }}
        </h4>
        <p class="toast__message">{{ description }}</p>
      </div>
      <button class="toast__close" @click="clearNotification">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <div class="toast__progress" :style="{ width: progressWidth }"></div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { capitalize } from "@/utils/helpers.js";

export default {
  name: "Toast",
  data() {
    return {
      timer: 0,
      notificationTimer: null,
      duration: 5000,
      elapsed: 0,
      progressInterval: null,
    };
  },

  computed: {
    ...mapState({
      alert: (state) => state.toast.type,
      description: (state) => state.toast.description,
      display: (state) => state.toast.display,
      messageTitle: (state) => state.toast.messageTitle,
    }),
    progressWidth() {
      return `${100 - (this.elapsed / this.duration) * 100}%`;
    },
  },

  methods: {
    ...mapActions(["showToast"]),

    capitalize,
    clearTimer() {
      clearInterval(this.notificationTimer);
      clearInterval(this.progressInterval);
      this.timer = 0;
    },
    startTimer() {
      this.notificationTimer = setInterval(() => {
        this.timer++;
      }, 1000);
      this.progressInterval = setInterval(() => {
        this.elapsed += 50;
      }, 50);
    },
    clearNotification() {
      this.showToast({
        description: "",
        display: false,
        type: "",
      });
      this.clearTimer();
      this.elapsed = 0;
    },
  },

  watch: {
    display(val) {
      if (val) {
        this.elapsed = 0;
        this.startTimer();
      } else {
        this.clearTimer();
      }
    },
    timer(val) {
      if (val === 5) {
        this.clearNotification();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.toast {
  position: fixed;
  top: 24px;
  right: 24px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 320px;
  max-width: 420px;
  padding: 16px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08);
  z-index: 9999;
  overflow: hidden;

  &__icon {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  &__content {
    flex: 1;
    min-width: 0;
    padding-top: 2px;
  }

  &__title {
    font-family: 'DM Sans', sans-serif;
    font-size: 15px;
    font-weight: 500;
    color: #0F172A;
    margin: 0 0 4px 0;
  }

  &__message {
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #64748B;
    margin: 0;
    line-height: 1.4;
  }

  &__close {
    width: 28px;
    height: 28px;
    background: transparent;
    border: none;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #94A3B8;
    cursor: pointer;
    flex-shrink: 0;
    transition: all 0.15s ease;
    margin: -4px -4px 0 0;

    &:hover {
      background: #F1F5F9;
      color: #64748B;
    }
  }

  &__progress {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 3px;
    transition: width 0.05s linear;
  }

  // Success variant
  &--success {
    .toast__icon {
      background: #ECFDF5;
      color: #10B981;
    }

    .toast__progress {
      background: #10B981;
    }
  }

  // Error variant
  &--error {
    .toast__icon {
      background: #FEF2F2;
      color: #EF4444;
    }

    .toast__progress {
      background: #EF4444;
    }
  }

  // Info variant
  &--info {
    .toast__icon {
      background: #EFF6FF;
      color: #4D84FF;
    }

    .toast__progress {
      background: #4D84FF;
    }
  }

  // Warning variant
  &--warning {
    .toast__icon {
      background: #FFFBEB;
      color: #F59E0B;
    }

    .toast__progress {
      background: #F59E0B;
    }
  }
}

// Slide animation
.toast-slide-enter-active,
.toast-slide-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.toast-slide-enter-from,
.toast-slide-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

.toast-slide-enter-to,
.toast-slide-leave-from {
  opacity: 1;
  transform: translateX(0);
}

// Mobile responsiveness
@media (max-width: 480px) {
  .toast {
    left: 16px;
    right: 16px;
    min-width: auto;
    max-width: none;
    top: 16px;
  }
}
</style>
